import { render, staticRenderFns } from "./AppTextEditor.vue?vue&type=template&id=310661d7&"
import script from "./AppTextEditor.vue?vue&type=script&lang=js&"
export * from "./AppTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./AppTextEditor.vue?vue&type=style&index=0&id=310661d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports